<template>
  <div>
    <!-- 面包屑组件 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/welcome' }">主页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/setMealList'}">套餐管理</el-breadcrumb-item>
      <el-breadcrumb-item>{{isEdit?'编辑套餐':'添加套餐'}}</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 内容卡片 -->
    <el-card>
      <div slot="header" class="clearfix">
        <span>{{isEdit?'编辑套餐':'添加套餐'}}</span>
      </div>
      <div>
        <el-form label-width="160px" :rules="rules" ref="fromData" :model="fromData" >
            <el-row :gutter="24">
                <el-col :span="8">
                    <el-form-item label="套餐名称" prop="name">
                        <el-input placeholder="请输入套餐名称" maxlength="50" v-model="fromData.name"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="套餐价格" prop="price">
                        <el-input placeholder="请输入套餐价格" v-model="fromData.price"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="套餐场景" prop="classType">
                <el-radio-group v-model="fromData.classType">
                  <el-radio
                    v-for="item in classTypeList"
                    :key="item.id"
                    :label="item.id"
                  >
                    {{ item.name }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="套餐类别" prop="type">
                <el-radio-group v-model="fromData.type">
                  <el-radio
                    v-for="item in setMealTypeList"
                    :key="item.id"
                    :label="item.id"
                  >
                    {{ item.name }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
            <el-row :gutter="24">
                <el-col :span="8" v-if="fromData.type=='3' || fromData.type=='1'">
                    <el-form-item label="消费次数" prop="times">
                        <el-input placeholder="请输入消费次数" v-model="fromData.times"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8" v-if="fromData.type=='3' || fromData.type=='1'">
                    <el-form-item label="赠送次数" prop="giveTimes">
                        <el-input placeholder="请输入赠送次数" v-model="fromData.giveTimes"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="24">
                <el-col :span="8" v-if="fromData.type=='4'">
                    <el-form-item label="消费时长（小时）" prop="times">
                        <el-input placeholder="请输入消费时长（小时）" v-model="fromData.hours"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8" v-if="fromData.type=='4'">
                    <el-form-item label="赠送时长（小时）" prop="giveTimes">
                        <el-input placeholder="请输入赠送时长（小时）" v-model="fromData.giveHours"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="24" class="longTiem_type" v-if="fromData.type=='3' || fromData.type=='2'">
                <el-col :span="8">
                    <el-form-item label="时长方式" class="el_radio_class" prop="longTimeOfType">
                        <el-radio v-model="fromData.longTimeOfType" :label="1">按天计算</el-radio>
                        <el-radio v-model="fromData.longTimeOfType" :label="2">按月计算</el-radio>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="消费时长" prop="longTimeOfNum">
                        <el-input placeholder="请输入时长天数" v-model="fromData.longTimeOfNum"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="赠送时长" prop="giveLongTimeOfNum">
                        <el-input placeholder="请输入赠送时长天数" v-model="fromData.giveLongTimeOfNum"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="24"  v-if="fromData.type=='3' || fromData.type=='2'">
                <el-col :span="8">
                    <el-form-item label="时长开始" class="el_radio_class" prop="longTimeOfStartType">
                        <el-radio v-model="fromData.longTimeOfStartType" :label="1">从购买之日算起</el-radio>
                        <el-radio v-model="fromData.longTimeOfStartType" :label="2">从第一次消费之日算起</el-radio>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="24">
                <el-col :span="12">
                    <el-form-item label="套餐简介" prop="description">
                        <el-input type="textarea" v-model="fromData.description"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
      </div>
    </el-card>

    <div class="footer-nav">
        <el-button type="primary" @click="submitForm('fromData')">确定</el-button>
        <el-button @click="resetForm('fromData')">取消</el-button>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        id:'',
        fromData:{
            type:'',
            classType:'0',
            price:'',
            name: '',
            giveLongTimeOfNum:'',
            giveTimes:'',
            hours:'',
            giveHours:'',
            longTimeOfNum:'',
            longTimeOfStartType:'',
            longTimeOfType:'',
            times:'',
            description:'',
            id:''
        },
        isEdit: false,
        // 套餐类别 1限次，2限时，3限次并限时
        setMealTypeList:[
          { id: 1, name: '限次' },
          // { id: 2, name: '限时' },
          // { id: 3, name: '限时限次' }
          { id: 4, name: '限小时' }
        ],
        classTypeList:[
          // { id: 0, name: '通用套餐' },
          { id: 1, name: '一对一套餐' },
          { id: 2, name: '班课套餐' }
        ],
        // 校验规则
        rules: {
          type: [
            { required: true, message: '请选择套餐类别', trigger: 'blur' }
          ],
          classType: [
            { required: true, message: '请选择套餐场景', trigger: 'blur' }
          ],
          name:[
            { required: true, message: '请输入套餐名称', trigger: 'blur' }
          ],
          deductTimes:[
            { required: true, message: '请填写信息', trigger: 'blur' }
          ],
        }
      };
    },
    created() {
        this.initDate();
    },
    methods: {
      async addSetMeal() {
        let url = this.isEdit?'/ea/student/setMeal/edit':"/ea/student/setMeal/add"
        const { data: res } = await this.$http.post(url,this.fromData);
        if (res.code !== 200) return this.$message.error(res.message);
        this.$message.success(this.isEdit?"编辑套餐成功":"新增套餐成功");
        this.$router.push({
            path: '/setMealList'
        })
      },
      initDate() {
          let params = this.$route.params;
          if(params && params.type=='edit'){
              this.fromData = params.recordDate
              this.isEdit = true;
          }
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.addSetMeal();
          } else {
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
        this.$router.push("/setMealList");
      }
  },
};
</script>

<style lang="less" scoped>
  /deep/ .el-upload__input{
    display: none;
  }
  .longTiem_type {
      .el_radio_class{
      }
  }
</style>
